// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"8e9b1fd4","400":"71453e3f","453":"65350b03","990":"8eeca491"}[chunkId] + ".chunk.js";
};